import { ICONS } from "@app/shared/constants/icons.constants";
import { MenuOption } from "@app/shared/models/menu.model";

export const MENU_OPTIONS = {
  /////
  // Generic components that are usable throughout the application
  /////
  HOME: <MenuOption>{
    id: "HomeComponent",
    icon: ICONS.HOME,
    itemDescription: {
      shortDescription: "MENUS.HomeComponent"
    }
  },
  DASHBOARD: <MenuOption>{
    id: "DashBoardComponent",
    icon: ICONS.DASHBOARD,
    itemDescription: {
      shortDescription: "MENUS.DashBoardComponent"
    }
  },
  MODULE: <MenuOption>{
    id: "ModuleContentComponent",
    icon: ICONS.APPLICATIONS_TAB,
    itemDescription: {
      shortDescription: "MENUS.ModuleContentComponent"
    }
  },
  IFRAME: <MenuOption>{
    id: "IframeComponent",
    icon: ICONS.IFRAME,
    itemDescription: {
      shortDescription: "MENUS.IframeComponent"
    }
  },
  PDF_VIEWER: <MenuOption>{
    id: "PdfViewerComponent",
    icon: ICONS.DOCUMENT_VIEW,
    itemDescription: {
      shortDescription: "MENUS.PdfViewerComponent",
      longDescription: "MENUS.PdfViewerComponent_DESC"
    }
  },
  ABOUT: <MenuOption>{
    id: "AboutComponent",
    icon: ICONS.INFO,
    itemDescription: {
      shortDescription: "MENUS.AboutComponent"
    }
  },
  HELP: <MenuOption>{
    id: "HelpComponent",
    icon: ICONS.HELP,
    itemDescription: {
      shortDescription: "MENUS.HelpComponent"
    }
  },
  USER_SETTINGS: <MenuOption>{
    id: "UserProfilesFormComponent",
    icon: ICONS.USER_SETTINGS,
    itemDescription: {
      shortDescription: "MENUS.UserProfilesFormComponent",
      modalTitle: "USER_PROFILES.LBL_SAVE_SETTINGS"
    }
  },

  /////
  // User Specific menu options
  /////
  USER: {
    MY_FAVORITES: <MenuOption>{
      id: "MUSER0001",
      icon: ICONS.FAVORITE,
      itemDescription: {
        shortDescription: "MENUS.MUSER0001",
        longDescription: "MENUS.MUSER0001_DESC"
      }
    },
    MY_REPORTS: <MenuOption>{
      id: "MUSER0002",
      icon: ICONS.REPORTS,
      itemDescription: {
        shortDescription: "MENUS.MUSER0002",
        longDescription: "MENUS.MUSER0002_DESC"
      }
    },
    ONDEMAND_REPORTS: <MenuOption>{
      id: "MUSER0003",
      icon: ICONS.ONDEMAND,
      itemDescription: {
        shortDescription: "MENUS.MUSER0003",
        longDescription: "MENUS.MUSER0003_DESC"
      }
    },
    INBASKET: <MenuOption>{
      id: "MUSER0004",
      icon: ICONS.INBOX,
      itemDescription: {
        shortDescription: "MENUS.MUSER0004",
        longDescription: "MENUS.MUSER0004_DESC"
      }
    },
    INBASKET_ATTACH: <MenuOption>{
      id: "MUSER0004A",
      icon: ICONS.INBOX,
      itemDescription: {
        shortDescription: "MENUS.MUSER0004",
        longDescription: "MENUS.MUSER0004_DESC"
      },
      security: {
        canMultiTab: true
      }
    },
    DOCUMENTS_PLUS: <MenuOption>{
      id: "MUSER0005",
      icon: ICONS.FOLDER_PLUS,
      itemDescription: {
        shortDescription: "MENUS.MUSER0005",
        longDescription: "MENUS.MUSER0005_DESC"
      }
    },
    DOCUMENT_WIZARD_LIST: <MenuOption>{
      id: "MUSER0006",
      icon: ICONS.DOCUMENTS,
      itemDescription: {
        shortDescription: "MENUS.MUSER0006",
        longDescription: "MENUS.MUSER0006_DESC"
      }
    },
    HINTS_TIPS: <MenuOption>{
      id: "MUSER0007"
    },
    ATTACH_DOCUMENTS: <MenuOption>{
      id: "MUSER0008",
      icon: ICONS.ATTACH_DOCUMENT,
      itemDescription: {
        shortDescription: "MENUS.MUSER0008",
        longDescription: "MENUS.MUSER0008_DESC"
      }
    }
  }
};
